import React from 'react';
import { useForm } from '@formspree/react';

function ContactForm() {
  const [state, handleSubmit] = useForm("mwkjnady");

  if (state.succeeded) {
    return (
      <section className="bg-[#162E3B] py-16 border-t border-[#FFD82D]/10">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center bg-white/5 border border-white/10 rounded-2xl p-8 sm:p-12 shadow-xl">
          <div className="w-16 h-16 bg-[#FFD82D]/10 border border-[#FFD82D] rounded-full flex items-center justify-center mx-auto mb-6">
            <span className="text-3xl text-[#FFD82D]">✓</span>
          </div>
          <h2 className="text-2xl font-extrabold text-white mb-4">Message Sent!</h2>
          <p className="text-gray-300 text-base sm:text-lg leading-relaxed">
            Thank you for reaching out. NevskiFit will review your details and contact you soon to arrange your free call.
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="bg-[#162E3B] py-16 lg:py-24 border-t border-[#FFD82D]/10">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        
        {/* Section Heading */}
        <div className="text-center mb-10">
          <h2 className="text-2xl sm:text-3xl font-extrabold text-white mb-4">
            Contact Me
          </h2>
          <p className="text-base sm:text-lg text-gray-300">
            Leave a message below and let's arrange your free call.
          </p>
        </div>

        {/* Contact Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="name" className="block text-base font-bold text-white mb-2">
              Your Name
            </label>
            <input 
              type="text" 
              name="name" 
              id="name"
              className="w-full py-3.5 px-5 text-base rounded-xl bg-white border-2 border-transparent text-gray-800 font-medium placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-[#FFD82D] transition-all" 
              placeholder="Enter your name" 
              required 
            />
          </div>

          <div>
            <label htmlFor="email" className="block text-base font-bold text-white mb-2">
              Your Email Address
            </label>
            <input 
              type="email" 
              name="email" 
              id="email"
              className="w-full py-3.5 px-5 text-base rounded-xl bg-white border-2 border-transparent text-gray-800 font-medium placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-[#FFD82D] transition-all" 
              placeholder="name@example.com" 
              required 
            />
          </div>

          <div>
            <label htmlFor="age" className="block text-base font-bold text-white mb-2">
              Your Age
            </label>
            <input 
              type="text" 
              name="age" 
              id="age"
              className="w-full py-3.5 px-5 text-base rounded-xl bg-white border-2 border-transparent text-gray-800 font-medium placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-[#FFD82D] transition-all" 
              placeholder="Enter your age" 
              required 
            />
          </div>

          <div>
            <label htmlFor="message" className="block text-base font-bold text-white mb-2">
              Your Message
            </label>
            <textarea 
              name="message" 
              id="message"
              rows="5" 
              className="w-full py-3.5 px-5 text-base rounded-xl bg-white border-2 border-transparent text-gray-800 font-medium placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-[#FFD82D] transition-all" 
              placeholder="e.g., Hi Sven! I am interested in home coaching. Can we schedule a call for this week?"
              required
            ></textarea>
          </div>

          <div className="pt-2">
            <button 
              type="submit" 
              disabled={state.submitting}
              className="w-full py-4 bg-[#FFD82D] text-[#162E3B] font-extrabold text-lg rounded-xl shadow-lg border-2 border-transparent hover:bg-white hover:text-[#162E3B] transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-[#FFD82D] disabled:opacity-50 disabled:cursor-not-allowed active:scale-98"
            >
              {state.submitting ? 'Sending Message...' : 'Send Message'}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}

export default ContactForm;
